<template>
    <div>
        <div v-if="step === 1">
            <v-list>
                <v-list-item v-for="step in steps" :key="step">
                    <p class="my-0">{{ step }}</p>
                </v-list-item>

            </v-list>

            <v-card-actions>
                <v-btn color="primary" @click="generate" :loading="loading">Begin Setup</v-btn>
            </v-card-actions>
        </div>

        <div v-if="step === 2">
            <v-card-title>
                <h4>Using the Authenticator app</h4>
            </v-card-title>
            <v-card-text>
                <p class="my-0">Scan the Barcode with your app</p>
            </v-card-text>

            <div class="d-flex align-center px-5">
                <v-avatar size="120px" rounded="0">
                    <img :src="'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + url" alt="qr code">
                </v-avatar>
                <v-card-text>
                    <p>Or enter the following code manually</p>
                    <p class="font-weight-bold my-0">{{ secret }}</p>
                    <v-btn @click="copySecret">Copy Text</v-btn>
                </v-card-text>
            </div>

            <v-card-subtitle>
                <p class="my-0">Enter the 6-digit authentication code generated by the app</p>
            </v-card-subtitle>

            <div class="px-5">
                <dtunes-otpinput v-model="otp" autofocus :CODE_LENGTH="6" />
            </div>

            <v-card-actions class="mt-4">
                <v-btn color="primary" @click="validateCode" :loading="loading">Proceed</v-btn>
                <v-btn @click="step--">Back</v-btn>
            </v-card-actions>
        </div>
    </div>
</template>

<script>
import DtunesOtpinput from './dtunes-otp-input.vue';
import { AuthService } from '@/services';
import { mapActions } from "vuex";
export default {
    data() {
        return {
            loading: false,
            step: 1,
            otp: '',
            secret: '',
            url: '',
            steps: [
                '1. Download and install an authenticator app on your mobile device',
                '2. Scan the QR code using the Google Authenticator app or copy the text and paste in the app',
                '3. Enter and verify the 6 digit code generated by the app'
            ]
        }
    },
    components: {
        DtunesOtpinput
    },
    methods: {
        ...mapActions("auth", ["verify2FA"]),
        async generate() {
            this.loading = true
            try {
                const data = await AuthService.generate2FA()
                this.url = data.otpauthUrl
                this.secret = data.secret
                this.loading = false
                this.step = 2
            } catch (error) {
                this.loading = false
            }
        },
        async validateCode() {
            this.loading = true
            try {
                await this.verify2FA({
                    token: this.otp,
                });
                this.loading = false
            } catch (error) {
                this.loading = false
            }
        },
        copySecret() {
            navigator.clipboard.writeText(this.secret)
            this.$store.dispatch('toast', {
                message: `Copied to clipboard`,
                variant: 'success'
            });
        }
    }
}
</script>

<style scoped>
img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
}
</style>